
import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { wissenstypen } from './sections/wissenstypen';
import { selbstreflektion } from './sections/selbstreflektion';
import { fazit } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    intro,
    wissenstypen,
    selbstreflektion,
    fazit
  ]
};
